import { render, staticRenderFns } from "./addEditCompanyTem.vue?vue&type=template&id=3844c7e4&scoped=true"
import script from "./addEditCompanyTem.vue?vue&type=script&lang=js"
export * from "./addEditCompanyTem.vue?vue&type=script&lang=js"
import style0 from "./addEditCompanyTem.vue?vue&type=style&index=0&id=3844c7e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3844c7e4",
  null
  
)

export default component.exports